import * as Yup from 'yup';

export const programRegistrationInitialValues = {
  firstName: '',
  paternalLastName: '',
  maternalLastName: '',
  dni: '',
  phone: '',
  email: '',
  interest: '',
  dataConsent: false,
  commercialConsent: true,
};

export const programRegistrationSchema = Yup.object({
  firstName: Yup.string().trim().required('El nombre es obligatorio'),
  paternalLastName: Yup.string().trim().required('El apellido paterno es obligatorio'),
  maternalLastName: Yup.string().trim().required('El apellido materno es obligatorio'),
  dni: Yup.string().trim(),
  phone: Yup.string().trim().required('El celular es obligatorio'),
  email: Yup.string().trim().email('Ingresa un email válido').required('El email es obligatorio'),
  interest: Yup.string().required('Selecciona una opción'),
  dataConsent: Yup.boolean().oneOf([true], 'Debes autorizar el tratamiento de datos'),
  commercialConsent: Yup.boolean(),
});
